<template>
  <div v-loading="loading">
    <QS-h4-title title="车源信息发布" />
    <el-form ref="form" :model="searchForm" :rules="rules" :inline="true" label-width="100px">
      <el-row>
        <el-col>
          <el-form-item label="信息标题" prop="title">
            <el-input v-model="searchForm.title" placeholder="请输入" maxlength="20" clearable />
          </el-form-item>
          <CarBrandSeriesModel
            v-model="searchForm.brandSeriesModel"
            :showModel="true"></CarBrandSeriesModel>
          <el-form-item label="方案类型" prop="leaseType">
            <el-select clearable filterable v-model="searchForm.leaseType" placeholder="请选择" @change="leaseTypeChangeEvent">
              <el-option v-for="item in LEASE_TYPE_OPTIONS" :label="item.label" :value="item.value" :key="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="交车城市" prop="transactionCityCode">
            <el-select clearable filterable v-model="searchForm.transactionCityCode" placeholder="请选择">
              <el-option v-for="item in allCities" :key="item.adcode" :label="item.city" :value="item.adcode" />
            </el-select>
          </el-form-item>
          <el-form-item label="金融机构" prop="financialInstitution" v-if="byLease">
            <el-select clearable filterable v-model="searchForm.financialInstitution" placeholder="请选择">
              <el-option v-for="item in financialInstitution" :label="item.label" :value="item.value" :key="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="租赁模式" prop="leaseModel" v-if="byLease">
            <el-select clearable filterable v-model="searchForm.leaseModel" placeholder="请选择">
              <el-option v-for="item in leaseModel" :label="item.label" :value="item.value" :key="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="还款方式" prop="repaymentMethod" v-if="byLease">
            <el-select clearable filterable v-model="searchForm.repaymentMethod" placeholder="请选择">
              <el-option v-for="item in repaymentMethod" :label="item.label" :value="item.value" :key="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="车辆单价" prop="unitPrice" v-if="byLease">
            <el-input v-model="searchForm.unitPrice" placeholder="请输入" clearable :disabled="searchForm.leaseProgrammes.length > 0" />
          </el-form-item>
          <el-form-item label="库存量" prop="inventory">
            <el-input v-model="searchForm.inventory" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item>
            <template v-slot:label>
              <span style="color: red">*&nbsp;</span>租赁方案
            </template>
            <el-button type="primary" @click="createEvent">新建方案</el-button>
            <QS-common-table :data="searchForm.leaseProgrammes" :columns="columns" :pagination="false" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="附加服务" prop="additionalServices">
            <el-checkbox-group v-model="searchForm.additionalServices">
              <el-checkbox v-for="item in specialAssetsArr" :label="item.key" :key="item.key">{{ item.name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="详情描述" prop="detailDesc">
            <el-input :rows="4" type="textarea" style="width: 500px" show-word-limit maxlength="500" v-model="searchForm.detailDesc" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="车辆图片">
            <UploadCommon
              acceptType=".pdf,.png,.jpg,.jpeg,.webp,.bmp"
              commonUpload
              group="assert"
              code="assert_material_pic"
              :fileList="searchForm.picture"
              :limit="10"
              :isAlone="false"
              @uploadBefore="uploadBefore"
              @uploadSuccess="uploadSuccess"
              @uploadError="uploadError"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="footerBtn">
      <el-button @click="cancelEvent">取消</el-button>
      <el-button type="primary" :loading="loadingBtn" @click="saveEvent(1)">保存</el-button>
      <el-button type="primary" :loading="loadingBtn" @click="saveEvent(2)">保存并发布</el-button>
    </div>
    <ProjectDialog ref="refProjectDialog" :type="dialogType" :byLease="byLease" :searchForm="searchForm" @addRow="addRow" @editRow="editRow" />
  </div>
</template>

<script>
import { validatorInterest } from '@/utils/validate.js'
import ProjectDialog from './components/projectDialog.vue'
// eslint-disable-next-line import/no-cycle
import { infoManageDetail, infoManagePublishAdd, infoManagePublishEdit } from '@/api/carResource/index.js'
import { LEASE_TYPE_OPTIONS, specialAssetsArr, columns1, columns2, LEASE_TYPE } from '../const.js'
import { mapGetters, mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  components: { ProjectDialog },
  data() {
    return {
      LEASE_TYPE_OPTIONS,
      specialAssetsArr,
      dialogType: 'add',
      searchForm: {
        title: '',
        brandId: '',
        seriesId: '',
        leaseType: Number(this.$route.query.leaseType) || LEASE_TYPE.FINANCIAL,
        transactionCityCode: '',
        financialInstitution: '',
        leaseModel: '',
        repaymentMethod: '',
        unitPrice: '',
        inventory: '',
        additionalServices: [],
        detailDesc: '',
        picture: [],
        leaseProgrammes: [],
        brandSeriesModel: {},
        modelId: '',
      },
      rules: {
        title: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        brandId: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        modelId: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        leaseType: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        transactionCityCode: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        financialInstitution: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        leaseModel: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        repaymentMethod: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        unitPrice: [{ required: true, validator: validatorInterest, trigger: ['blur', 'change'], max: 1000000 }],
        inventory: [{ required: false, validator: validatorInterest, trigger: ['blur', 'change'], max: 9999, integer: true }],
      },
      loading: false,
      loadingBtn: false,
      brandList: [],
      seriesList: [],
    }
  },
  computed: {
    ...mapState({
      financialInstitution: (state) => state.carResource.financialInstitution,
      repaymentMethod: (state) => state.carResource.repaymentMethod,
      leaseModel: (state) => state.carResource.leaseModel,
    }),
    ...mapGetters(['allCities']),
    byLease() {
      // 2经租 1融租
      return this.searchForm.leaseType === LEASE_TYPE.FINANCIAL
    },
    columns() {
      const appendColum = {
        name: 'irr',
        columnProps: {
          label: 'IRR',
          prop: 'irr',
          width: '120px',
        },
        getText: ({ row }) => (row.irr ? `${row.irr}%` : '--'),
      }
      const preColumns = this.byLease ? columns1.concat(appendColum) : columns2
      return [
        ...preColumns,
        {
          name: 'operate',
          type: 'operate',
          columnProps: {
            label: '操作列',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            return [
              { name: 'edit', label: '编辑', action: () => this.handleEditBtnClick(row) },
              { name: 'delete', label: '删除', action: () => this.handleDeleteBtnClick(row) },
            ]
          },
        },
      ]
    },
  },
  mounted() {
    this.initFilters()
    this.getDetail()
  },
  watch: {
    'searchForm.brandSeriesModel': {
      handler(val) {
        const { brandId, seriesId, modelId } = val
        this.searchForm.brandId = brandId
        this.searchForm.seriesId = seriesId
        this.searchForm.modelId = modelId
        // 只在提交触发校验
        this.$nextTick(() => {
          this.$refs.form.clearValidate('brandId')
          this.$refs.form.clearValidate('modelId')
        })
      },
      deep: true,
    },
  },
  methods: {
    // 初始化筛选项数据
    initFilters() {
      const filters = ['financialInstitution', 'repaymentMethod', 'leaseModel']
      filters.forEach((item) => {
        if (this[item].length === 0) {
          this.$store.dispatch('getCarResourceEnum', item)
        }
      })
    },
    getDetail() {
      const { carResourceId } = this.$route.query
      if (!carResourceId) return
      this.loading = true
      infoManageDetail({ carResourceId }).then((res) => {
        const { code, data } = res || {}
        if (code === 1) {
          try {
            data.additionalServices = JSON.parse(data.additionalServices)
          } catch (e) {
            data.additionalServices = []
            Sentry.captureException(e)
          }
          data.picture = this.getURL({
            data: data.picture,
            needName: true,
          })
          data.leaseProgrammes.forEach((item, i) => {
            item.index = i + 1
          })
          for (const i in this.searchForm) {
            this.searchForm[i] = data[i]
          }
          this.searchForm.brandSeriesModel = {
            brandId: data.brandId,
            modelId: data.modelId,
            seriesId: data.seriesId,
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    createEvent() {
      // 融租时先校验车辆单价
      if (this.byLease) {
        this.$refs.form.validateField('unitPrice', (errorMessage) => {
          if (errorMessage) {
            this.$message.warning('请先输入正确的车辆单价')
          } else {
            this.createProject()
          }
        })
      } else {
        this.createProject()
      }
    },
    createProject() {
      if (this.searchForm.leaseProgrammes.length >= 10) {
        this.$message.warning('最多可添加10个租赁方案')
        return
      }
      this.dialogType = 'add'
      this.$refs.refProjectDialog.openDialog()
    },
    handleEditBtnClick(row) {
      this.dialogType = 'edit'
      this.$refs.refProjectDialog.openDialog(row)
    },
    handleDeleteBtnClick(row) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        // 查找删除行的索引
        const findIndex = this.searchForm.leaseProgrammes.findIndex((item) => item.index === row.index)
        // 找到了，执行删除
        if (findIndex > -1) {
          this.searchForm.leaseProgrammes.splice(findIndex, 1)
          // 重新排索引
          const tempLeaseProgrammes = [...this.searchForm.leaseProgrammes]
          tempLeaseProgrammes.forEach((item, i) => {
            item.index = i + 1
          })
          this.searchForm.leaseProgrammes = tempLeaseProgrammes
        }
      }).catch(() => null)
    },
    addRow(rowData) {
      // 编辑时，新增数据的索引开始值
      const sum = this.searchForm.leaseProgrammes.length
      this.searchForm.leaseProgrammes.push({ ...rowData, index: sum + 1 })
    },
    editRow(rowData) {
      // 查找编辑的行
      const editItem = this.searchForm.leaseProgrammes.find((item) => item.index === rowData.index)
      if (editItem) {
        // 更新编辑的行的数据
        for (const i in rowData) {
          this.$set(editItem, i, rowData[i])
        }
      }
    },
    saveEvent(saveType) {
      if (this.searchForm.leaseProgrammes.length === 0) {
        this.$message.error('请添加租赁方案')
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          let infoManagePublish = infoManagePublishAdd
          const params = { ...this.searchForm }
          params.saveType = saveType
          params.additionalServices = JSON.stringify(params.additionalServices)
          params.picture = JSON.stringify(params.picture)
          params.leaseProgrammes.forEach((item) => {
            delete item.index
          })
          delete params.brandSeriesModel
          const { carResourceId } = this.$route.query
          if (carResourceId) {
            infoManagePublish = infoManagePublishEdit
            params.carResourceId = carResourceId
          }
          infoManagePublish(params).then((res) => {
            if (res?.code === 1) {
              this.$message({ type: 'success', message: saveType === 1 ? '保存成功' : '保存并发布成功' })
              this.$refreshBack(true)
              this.$router.push({ path: '/purchaseProvide/infoManage' })
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    cancelEvent() {
      this.$refreshBack(false)
    },
    uploadBefore() {
      this.loadingBtn = true
    },
    uploadSuccess() {
      this.loadingBtn = false
    },
    uploadError() {
      this.loadingBtn = false
    },
    // 更换方案时清空table里已添加的数据
    leaseTypeChangeEvent() {
      this.searchForm.leaseProgrammes = []
    },
  },
}
</script>
<style lang='less' scoped>
.footerBtn {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  button {
    margin-right: 30px;
  }
}
</style>
